import type { PatientId } from "@repo/domain";
import { createContext, type ReactNode, useContext } from "react";

/**
 * Who the note is about. A phrase writes its record against this patient, so
 * an editor without one shows the phrases it already has but cannot add or
 * change any.
 */
const SmartPhraseContext = createContext<{ patientId?: PatientId }>({});

export function SmartPhraseProvider({ patientId, children }: { patientId?: PatientId; children: ReactNode }) {
  return <SmartPhraseContext.Provider value={{ patientId }}>{children}</SmartPhraseContext.Provider>;
}

export function useSmartPhrasePatient(): PatientId | undefined {
  return useContext(SmartPhraseContext).patientId;
}
